import React from 'react';
import { useTranslation } from 'react-i18next';

const AboutPage: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-md overflow-hidden p-8">
        <div className="text-center mb-10 border-b pb-6">
          <h1 className="text-4xl font-bold text-gray-900 mb-2">{t('aboutPage.title')}</h1>
          <p className="text-lg text-gray-600">{t('aboutPage.subtitle')}</p>
        </div>

        <div className="prose prose-lg max-w-none text-gray-700 leading-relaxed space-y-6">
          <section>
            <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-800 border-b pb-2 pt-4">{t('aboutPage.mission.title')}</h2>
            <p className="mb-4">{t('aboutPage.mission.content')}</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-800 border-b pb-2 pt-4">{t('aboutPage.whatWeDo.title')}</h2>
            <p className="mb-4">{t('aboutPage.whatWeDo.content')}</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-800 border-b pb-2 pt-4">{t('aboutPage.whyParaguay.title')}</h2>
            <p className="mb-4">{t('aboutPage.whyParaguay.content')}</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-800 border-b pb-2 pt-4">{t('aboutPage.values.title')}</h2>
            <ul className="list-none space-y-3">
              <li className="flex items-start">
                <span className="mr-2 text-blue-600 font-bold">&#8226;</span>
                <span>{t('aboutPage.values.transparency')}</span>
              </li>
              <li className="flex items-start">
                <span className="mr-2 text-blue-600 font-bold">&#8226;</span>
                <span>{t('aboutPage.values.excellence')}</span>
              </li>
              <li className="flex items-start">
                <span className="mr-2 text-blue-600 font-bold">&#8226;</span>
                <span>{t('aboutPage.values.trust')}</span>
              </li>
              <li className="flex items-start">
                <span className="mr-2 text-blue-600 font-bold">&#8226;</span>
                <span>{t('aboutPage.values.innovation')}</span>
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold mt-8 mb-4 text-gray-800 border-b pb-2 pt-4">{t('aboutPage.contact.title')}</h2>
            <p className="mb-4">{t('aboutPage.contact.content')}</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
